export default "__VITE_ASSET__63e80d41__"